import { useEffect, useRef } from "react";
import boblogo from "../../Assest/ServicesCarouselLogoImage/Bank_of_Baroda_logo 1.png";
import kotaklogo from "../../Assest/ServicesCarouselLogoImage/Kotak.png";
import axislogo from "../../Assest/ServicesCarouselLogoImage/axis bank.png";
import radiantlogo from "../../Assest/ServicesCarouselLogoImage/radiant acemoney.png";
import yeslogo from "../../Assest/ServicesCarouselLogoImage/yesBank.png";
import smartpinglogo from "../../Assest/ServicesCarouselLogoImage/smart ping 1.png";
import perfinlogo from "../../Assest/ServicesCarouselLogoImage/prefinn.png";
import payulogo from "../../Assest/ServicesCarouselLogoImage/PayU.png";
import idfcfirstlogo from "../../Assest/ServicesCarouselLogoImage/Logo_of_IDFC_First_Bank.png";
import indusinlogo from "../../Assest/ServicesCarouselLogoImage/indusind-bank 1.png";
import hdfclogo from "../../Assest/ServicesCarouselLogoImage/HDFC-Bank-logo 1.png";
import easemytriplogo from "../../Assest/ServicesCarouselLogoImage/EaseMyTrip_Logo.png";
import bajafinancelogo from "../../Assest/ServicesCarouselLogoImage/bajajFinance.png";
import bajaallizlogo from "../../Assest/ServicesCarouselLogoImage/Bajaj.png";

const logos = [
  boblogo,
  kotaklogo,
  axislogo,
  radiantlogo,
  yeslogo,
  smartpinglogo,
  perfinlogo,
  payulogo,
  idfcfirstlogo,
  indusinlogo,
  hdfclogo,
  easemytriplogo,
  bajafinancelogo,
  bajaallizlogo,
];

export default function ServicesCarousel() {
  const sliderRef = useRef(null);
  const animationRef = useRef(null);
  const isPaused = useRef(false);

  useEffect(() => {
    const slider = sliderRef.current;
    let scrollAmount = 0;

    const slide = () => {
      if (!isPaused.current) {
        scrollAmount += 0.5; // speed
        if (scrollAmount >= slider.scrollWidth / 2) {
          scrollAmount = 0;
        }
        slider.scrollLeft = scrollAmount;
      }
      animationRef.current = requestAnimationFrame(slide);
    };

    slide();

    return () => cancelAnimationFrame(animationRef.current);
  }, []);

  return (
    <section className="bg-white py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-14">
          <h2 className="text-3xl font-bold">
            OUR BANKING PARTNERS
          </h2>
        </div>

        {/* Logo Slider */}
        <div
          ref={sliderRef}
          onMouseEnter={() => (isPaused.current = true)}
          onMouseLeave={() => (isPaused.current = false)}
          className="flex gap-16 overflow-x-hidden whitespace-nowrap cursor-pointer"
        >
          {[...logos, ...logos].map((logo, index) => (
            <div
              key={index}
              className="min-w-[180px] flex items-center justify-center"
            >
              <img
                src={logo}
                alt="partner logo"
                className="h-16 object-contain transition-transform duration-300 hover:scale-110"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
